// src/hooks/programs/useSaveProgramPdfTexts.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { saveProgramPdfTexts } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useSaveProgramPdfTexts = () => {
    const queryClient = useQueryClient();

    const {
        mutate: savePdfTextsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, data }) => saveProgramPdfTexts(id, data),
        onSuccess: (response, variables) => {
            toast.success(response.message || "PDF texts saved successfully");
            queryClient.invalidateQueries({ 
                queryKey: ["program-pdf-sections", variables.id] 
            });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to save PDF texts");
        },
    });

    return {
        savePdfTextsMutate,
        isPending: isPending || isLoading,
    };
};

export default useSaveProgramPdfTexts;
